import * as React from "react"
import Svg, { Rect, Path } from "react-native-svg"

function SvgComponent(props) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            {...props}
        >
            <Rect width={40} height={40} rx={20} fill="#F3F5FC" />
            <Path
                d="M28.572 18.718H26.75v-6a3.428 3.428 0 00-3.428-3.429h-6.643a3.428 3.428 0 00-3.429 3.429v6H11.43a.856.856 0 00-.857.857V29.86c0 .475.383.858.857.858H28.57a.856.856 0 00.858-.858V19.575a.856.856 0 00-.857-.857zm-13.393-6c0-.828.672-1.5 1.5-1.5h6.643c.827 0 1.5.672 1.5 1.5v6h-9.643v-6zM27.5 28.789h-15v-8.143h15v8.143zm-8.25-3.723v1.42c0 .117.096.214.214.214h1.072a.215.215 0 00.214-.215v-1.42a1.286 1.286 0 10-1.5 0z"
                fill="#1434CB"
            />
        </Svg>
    )
}

export default SvgComponent
